export const ExpressPayStatus = {
  not_requested: 'Not Requested', // has not requested express pay at all
  requested: 'Requested', // has requested express pay and maybe processed
  waived: 'Waived', // has requested express pay and waived (amount won't be deducted from payout)
  not_used: 'Not Used', // express pay request has been deleted or removed
};
